<template>
<div class="container">
	<!-- <div v-if="showTable" class="vx-row">
		<vs-button @click="showTable=false;">Cacher les factures antérieures</vs-button>
	</div>
	<div v-else class="vx-row">
		<vs-button @click="getCustomer()">Afficher les factures antérieures</vs-button>
	</div> -->
	<div v-show="showTable" class="vx-row">
		<FacturationTable :contract_id="$props.pending_invoice.contract_id" :exportInvoiceDetail="true" @export-invoice="exportInvoices($event)" @export-invoice-item="exportInvoicesItem($event)"/>
	</div>
</div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import FacturationTable from "@/components/tables/FacturationTable";

export default {
	name: "InvoiceFacturationTable",
	components: {
		FacturationTable
	},
	props: {
		pending_invoice: Object,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			list: [],
			loader: false,
			error: false,
			showTable: true,
		};
	},
	// created() {
	// 	if(this.pending_invoice && this.list.length == 0){
	// 		this.getCustomer();
	// 	}
	// },
	// watch: {
	// 	pending_invoice: function() {
	// 		this.getCustomer();
	// 	},
	// },
	// computed: {
	// },
	// updated(){
	// },
	methods: {
		exportInvoices(invoice_details){
			this.$emit("export-invoice", invoice_details);
		},
		exportInvoicesItem(invoice_details){
			this.$emit("export-invoice-item", invoice_details);
		},

		// getCustomer(){
		// 	this.loader = true;
		// 	this.showTable = true;
		// 	this.$http.get(this.apiUrl + "pending_invoices/customers/society/" + this.pending_invoice.society_id)
		// 		.then(res => {
		// 			if(res.data.length > 0){
		// 				this.$http.get(this.apiUrl + "qb/action_select/get_contract_invoices/" + this.pending_invoice.contract_id + "/" + res.data[0].quickbooks_customer_id)
		// 					.then(result => {
		// 						this.list = result.data;
		// 						this.loader = false;
		// 						this.error = false;
		// 					});
		// 			}
		// 			else{
		// 				this.loader = false;
		// 			}
		// 		})
		// 		.catch(err => {
		// 			this.loader = false;
		// 			this.error = true;
		// 		});
		// },
	}
};
</script>

<style>
div.content-tr-expand{
	padding: 0;
}
.loader:after {
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
  animation: ellipsis 1.5s infinite;
  content: "......";
  font-weight: bold;
}
@keyframes ellipsis {
  from {
    width: 2px;
  }
  to {
    width: 15px;
  }
}
</style>
